import { getKSwitch } from './kswitch';

const PREFIX = 'KdsReactMinBundleVersion';

const cache = {};
export const getMinBundleVersionById = async bundleId => {
    if (cache[bundleId]) {
        return cache[bundleId];
    }

    const startTime = Date.now();
    const res = await getKSwitch([
        {
            key: `${PREFIX}${bundleId}`,
        },
    ]);
    cache[bundleId] = res?.[0]?.value || 0;

    console.log(`[MinBundleVersion]: bundleId: ${bundleId} 、 minBundleVersion: ${cache[bundleId]} 、 cost time: ${Date.now() - startTime}`);

    return cache[bundleId] || 0;
};
